import { otmsHttp, wmsHttp } from '@/utils/http/index.js'

/**
 * 货主SKU分页
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8750
 */
export function fetchSkuPage(data, params) {
    return otmsHttp.request({
        url: '/customer/sku/page',
        method: 'post',
        data,
        params
    })
}
export function fetchSkuPageV2(data) {
    return otmsHttp.request({
        url: '/base_plus/use/snapshot/goods/list',
        method: 'post',
        data,
    })
}


/**
 * 货主创建SKU
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8746
 */
export function createSku(data) {
    return otmsHttp.request({
        url: '/customer/sku/create',
        method: 'post',
        data,
    })
}


/**
 * 货品品类列表
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/19265
 */
 export function getLevelTree() {
    return wmsHttp.post('/warehouse_foundation/goods_level/tree')
}